<template>
  <div>
    <div class="mb10">
      <el-button
        v-permit:remove="'btn:payable:quoteManagement:addEdit'"
        size="small"
        type="primary"
        @click="handleAdd"
      >
        {{ $t('basicData.AddARow') }}
      </el-button>
    </div>

    <!-- 表格组件 -->
    <table-cmp
      :ref="currentTableRef"
      :table-data="currentTableData"
      @change="handleTableChange"
    />
  </div>
</template>

<script>
import TableCmp from './TableCmp';
import { validatePrice, ROW_TMP } from './utils';
import { cloneDeep } from 'lodash-es';

export default {
  name: 'AjdPriceDetail',

  components: {
    TableCmp
  },

  props: {
    // 方案id
    partitionId: {
      type: [Number, String],
      default: ''
    },
    // 分区id
    partitionAffiliateId: {
      type: [String, Number],
      default: ''
    },
    // 分区明细
    subregionList: {
      type: Array,
      default: () => []
    },
    // table数据
    tableData: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      // 默认数据
      defaultPartitionObj: {
        default: { arr: [] }
      },
      // 默认分区明细
      partitionObj: {}
    };
  },

  computed: {
    // 是否存在方案id
    hasNoPartition() {
      return !this.partitionId;
    },
    // tableRef
    currentTableRef() {
      return this.hasNoPartition ? 'defaultTableRef' : 'tableRef';
    },
    // 当前分区数据
    currentPartitionData() {
      return this.partitionObj[this.partitionAffiliateId]?.arr || [];
    },

    currentTableData() {
      return this.hasNoPartition
        ? this.defaultPartitionObj.default.arr
        : this.currentPartitionData;
    }
  },

  watch: {
    partitionId: {
      handler: 'handlePartitionChange',
      immediate: true
    },
    subregionList: {
      handler: 'initData',
      deep: true
    },
    tableData: {
      handler: 'initData',
      deep: true
    }
  },

  methods: {
    // 初始数据-避免回显失败
    async initData() {
      await this.handlePartitionChange();
      await this.setData();
    },
    handlePartitionChange() {
      console.log('AJD-初始化分区-112', this.partitionId, this.subregionList);
      if (this.hasNoPartition) {
        this.defaultPartitionObj.default.arr = [];
        return;
      }

      if (this.subregionList.length === 0) return;
      this.clearPartitionData();
      this.initializePartitionData();
    },
    // 重置
    clearPartitionData() {
      this.partitionObj = {};
    },
    // 初始化分区数据
    initializePartitionData() {
      const partitionIds = this.subregionList.map(item => item.id);
      partitionIds.forEach(id => {
        this.$set(this.partitionObj, id, { arr: [] });
      });
    },

    handleAdd() {
      const newRow = { ...ROW_TMP };

      if (this.hasNoPartition) {
        this.defaultPartitionObj.default.arr.push(newRow);
        return;
      }

      if (this.partitionObj[this.partitionAffiliateId]) {
        this.partitionObj[this.partitionAffiliateId].arr.push(newRow);
      }
    },
    // 表格数据更新
    handleTableChange(arr) {
      if (arr.length === 0) return;

      if (this.hasNoPartition) {
        this.defaultPartitionObj.default.arr = arr;
      } else {
        this.partitionObj[this.partitionAffiliateId].arr = arr;
      }
    },
    // 提交表单校验
    async submitForm() {
      // 无分区
      if (this.hasNoPartition) {
        return await this.validateDefaultPartition();
      }
      return await this.validatePartitionData();
    },
    // 默认数据校验
    async validateDefaultPartition() {
      if (this.defaultPartitionObj.default.arr.length === 0) {
        this.showErrorMessage('basicData.PleaseAddDetails');
        return false;
      }

      const isValid = await this.$refs['defaultTableRef'].submitForm();
      if (!isValid) {
        this.showErrorMessage('operatingPlatform.PleaseFillInTheRequiredFields');
      }
      return isValid;
    },
    // 分区明细校验
    async validatePartitionData() {
      const hasData = this.checkPartitionHasData();
      if (!hasData) {
        this.showErrorMessage('basicData.PleaseAddDetails');
        return false;
      }

      const currentValid = await this.validateCurrentPartition();
      console.log('AJD-currentValid-185', currentValid);
      if (!currentValid) return false;

      return await this.validateOtherPartitions();
    },
    // 分区是否存在数据
    checkPartitionHasData() {
      return Object.values(this.partitionObj).some(partition =>
        partition.arr.length > 0
      );
    },
    // 校验当前选中分区
    async validateCurrentPartition() {
      const isValid = await this.$refs['tableRef'].submitForm();
      if (!isValid) {
        this.showErrorMessage('basicData.CheckFail');
      }
      return isValid;
    },
    // 校验其他分区
    async validateOtherPartitions() {
      const invalidPartitionIds = this.getInvalidPartitionIds();
      if (invalidPartitionIds.length === 0) return true;

      this.showInvalidPartitionsError(invalidPartitionIds);
      return false;
    },
    // 获取无效分区id
    getInvalidPartitionIds() {
      const invalidIds = [];
      for (const key in this.partitionObj) {
        const isBool = validatePrice(this.partitionObj[key].arr);
        console.log('isBool-191', isBool);
        if (!isBool) {
          invalidIds.push(key);
        }
      }
      console.log('invalidIds-205', invalidIds);
      return invalidIds;
    },

    showInvalidPartitionsError(invalidPartitionIds) {
      const invalidNames = this.getInvalidPartitionNames(invalidPartitionIds);
      this.$message.warning(`${invalidNames}${this.$t('basicData.CheckFail')}`);
    },

    getInvalidPartitionNames(invalidPartitionIds) {
      return this.subregionList
        .filter(item => invalidPartitionIds.includes(String(item.id)))
        .map(item => item.partitionIdentifier)
        .join(',');
    },

    showErrorMessage(messageKey) {
      this.$message.warning(this.$t(messageKey));
    },
    // 更新分区数据
    setData() {
      console.log('setData-224', this.tableData, this.partitionId, this.subregionList);
      try {
        const arr = cloneDeep(this.tableData);
        if (!arr || arr.length === 0) return;

        if (this.hasNoPartition) {
          this.defaultPartitionObj.default.arr = arr;
          return;
        }

        arr.forEach(item => {
          const { partitionAffiliateId } = item;
          if (!this.partitionObj[partitionAffiliateId]) {
            this.$set(this.partitionObj, partitionAffiliateId, { arr: [] });
          }
          this.partitionObj[partitionAffiliateId].arr.push(item);
        });
      } catch (error) {
        console.log('设置setData失败', error);
      }
    },
    // 获取数据
    getData() {
      // 无分区
      if (this.hasNoPartition) {
        return this.getDefaultPartitionData();
      }
      return this.getAllPartitionData();
    },

    getDefaultPartitionData() {
      return this.defaultPartitionObj.default.arr.map(item => ({
        ...item,
        partitionAffiliateId: undefined
      }));
    },

    getAllPartitionData() {
      const result = [];

      Object.entries(this.partitionObj).forEach(([key, partition]) => {
        if (partition.arr.length === 0) return;

        const partitionData = partition.arr.map(item => ({
          ...item,
          partitionAffiliateId: key
        }));

        result.push(...partitionData);
      });

      return result;
    }
  }
};
</script>
